export default "__VITE_ASSET__a6b16b88__"